import { google } from 'google-maps'

export type MapTypeId = 'terrain'|'roadmap'|'satellite'|'hybrid'

let marker: google.maps.Marker
let googleMaps: google.maps.Map
let googleInput: google.maps.places.Autocomplete

export function getGoogleInstance (): google {
  return window.google
}

export function getMap (): google.maps.Map {
  return googleMaps
}

export function getMarker (): google.maps.Marker {
  return marker
}

// Get user position
export function getCurrentPosition (googleMaps: google.maps.Map): void {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition((position) => {
      const coordinates = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      }
      googleMaps.setCenter(coordinates)
    }, function () {
      console.log('Error on get current position')
    })
  } else {
    console.log('Browser doesn\'t support Geolocation')
  }
}

export async function createGoogleMaps (elm: HTMLDivElement, mapTypeId: MapTypeId): Promise<google.maps.Map> {
  const google = getGoogleInstance()
  googleMaps = new google.maps.Map(elm, {
    zoom: 17,
    gestureHandling: 'cooperative',
    mapTypeId: mapTypeId,
    disableDefaultUI: true,
    zoomControl: true
  })

  getCurrentPosition(googleMaps)

  return googleMaps
}

export async function createGoogleInput (elm: HTMLInputElement): Promise<google.maps.places.Autocomplete> {
  if (googleInput) {
    return googleInput
  }

  const google = getGoogleInstance()
  googleInput = new google.maps.places.Autocomplete(elm, {
    types: ['establishment']
  })

  if (googleMaps) {
    googleInput.bindTo('bounds', googleMaps)
  }

  return googleInput
}

// Google Maps INIT
export async function loadGoogleMaps (): Promise<boolean> {
  const apiKey = process.env.REACT_APP_MAPS_API_KEY
  const libraries = 'places'
  const uri = 'https://maps.googleapis.com/maps/api/js'

  const script = document.querySelector('script')
  const src = script?.getAttribute('src') || ''
  if (src.search('googleapis') > -1) {
    return true
  }

  const googleMapsScript = document.createElement('script')
  googleMapsScript.src = `${uri}?key=${apiKey}&libraries=${libraries}&SameSite=None`
  window.document.body.appendChild(googleMapsScript)

  return new Promise((resolve) => {
    googleMapsScript.addEventListener('load', () => {
      return resolve(true)
    })
  })
}

export function setMarker (lat: number, lng: number, center = false): void {
  const google = getGoogleInstance()
  const googleMaps = getMap()

  if (google && googleMaps) {
    // If isse old marker
    if (getMarker()) {
      marker.setMap(null)
    }

    marker = new google.maps.Marker({
      position: { lat, lng },
      map: googleMaps
    })

    if (center) {
      const latLng = new google.maps.LatLng(lat, lng)
      googleMaps.setCenter(latLng)
    }
  }
}
